(function () {
    angular.module('tmx-app').controller('GuarantorEtbCtrl', ['$scope', 'BroadcastService', 'dynamicFormService', '$rootScope','$mdDialog','$timeout', GuarantorEtbCtrl]);
    function GuarantorEtbCtrl($scope, BroadcastService, dynamicFormService, $rootScope,$mdDialog,$timeout) {
        var GuarantorEtbVM = $scope;

        GuarantorEtbVM.GuarantorMappingData = dynamicFormService.applicationGuarantorMappingData;

        // GuarantorEtbVM.addInGrid = function()
        // {

        // }

        // BroadcastService.subscribe('refreshGuarantorStaticGrid',$scope,function(evt,data){    
        //     GuarantorEtbVM.GuarantorMappingData = dynamicFormService.applicationGuarantorMappingData;
        // });

        GuarantorEtbVM.updateGuarantorDetail = function () {
            GuarantorEtbVM.isPageLoading = true;
            $timeout(function()
            {
                BroadcastService.publish('updateGuarantorData', "");
                var index = dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMappingDummy[0].index;
                dynamicFormService.applicationGuarantorMappingData[index].TmxGuarantor = dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMappingDummy[0].TmxGuarantor;
                GuarantorEtbVM.isPageLoading = false;
            });
            
            
            
        }

        GuarantorEtbVM.addGuarantorDetail = function () {
            GuarantorEtbVM.isPageLoading = true;
            $timeout(function()
            {
                $rootScope.selectedTabId = 239;
                BroadcastService.publish('addGuarantorData', "");
                // dynamicFormService.applicationGuarantorMappingData.push(dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMapping[0]);
                GuarantorEtbVM.isPageLoading = false;
            });            
        }

        // GuarantorEtbVM.addGuarantorClick = function () {
        //     isPageLoading = true;
        //     $rootScope.selectedTabId = 239;
        //     dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMapping = [{}];
        //     dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMapping[0] = { TmxGuarantor: [{}] };
        //     BroadcastService.publish('reloadGuarantorData', "");
        //     isPageLoading = false;
        // }

        function DynamicGuarantorDialogCtrl($scope, $mdDialog) {

            $scope.showErrors = false;
            $scope.id = 5;
            $scope.applicationStatus = 0;
            $scope.applicationData = dynamicFormService.applicationData;
            var peripherals = {
                mustFields: [],//fields that must be filled irresepective of state of loan app
                locals: {
                }
            }
            var errorControl = {};
            $scope.tab = dynamicFormService.loadPage(dynamicFormService.guarantorTab,undefined,errorControl,peripherals);
            $scope.tab.read(dynamicFormService.applicationData,$scope.tab.fieldMap);
        }

        GuarantorEtbVM.editGuarantorClick = function (index,ev) {
            
            dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMappingDummy = [{}];
            dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMappingDummy[0] = GuarantorEtbVM.GuarantorMappingData[index];
            dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMappingDummy[0].index = index;
            dynamicFormService.applicationData['TmxLoanApplicationToGuarantorMappingDummy[0]'] = dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMappingDummy[0];
            dynamicFormService.applicationData['TmxLoanApplicationToGuarantorMappingDummy[0].TmxGuarantor'] = dynamicFormService.applicationData.TmxLoanApplicationToGuarantorMappingDummy[0].TmxGuarantor;

            $mdDialog.show({
                    controller: DynamicGuarantorDialogCtrl,
                    templateUrl: 'app/pages/dynamic-guarantor-dialog/dynamic-guarantor-dialog.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    locals: {},
                    clickOutsideToClose: true,
                    fullscreen: true,
                }).then(function (answer) {

                }, function () {

                });
        }

        GuarantorEtbVM.deleteGuarantorClick = function (index) {
            GuarantorEtbVM.GuarantorMappingData.splice(index, 1);
        }
    }
})();